import { apiSlice } from "./apiSlice";

export const authApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        signOut: builder.mutation({
            query: () => ({
                url: "/auth/signout",
                method: "POST"
            })
        })
    })
});

export const { 
    useSignOutMutation
} = authApiSlice;